import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

export const navigationBarContainerCss: CSSObject = {
  position: "relative",
  display: "flex",
  flexDirection: "row",
  height: "4rem",
  minHeight: "4rem",
  padding: "0 1rem 0 0.5rem",
  justifyContent: "space-between",
  borderBottom: `1px solid ${constants.colors.ui.neutral[100]}`,

  ul: {
    listStyleType: "none",
    margin: 0,
    padding: 0,
  },
};

export const navigationBarLeftContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "0.5rem",
};

export const getNavigationBarRightContainerCss = (
  isInitializing: boolean,
): CSSObject => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "0.5rem",
  ...(isInitializing && {
    visibility: "hidden",
    pointerEvents: "none",
  }),
});

export const getTrialButtonsVisibilityCss = (
  isVisible: boolean,
): CSSObject => ({
  display: "none",

  ...(isVisible && {
    display: "flex",
  }),
});
